import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actionGetRegionais,
  actionSelectRegional,
} from "../../../features/dados-loja/regionais/slices";
import factoryOptionsFields from "../../../helpers/factory-fields";
import { getUser } from "../../../helpers/user";
import Select from "../../Select";
import { useAppSelector } from "../../../hooks/useAppSelector";

interface IPropsSelectRegionais {
  idRegional?: string;
  onChange?: any;
}

const SelectRegionais = (props: IPropsSelectRegionais) => {
  const dispatch = useDispatch();
  const { acesso } = getUser();
  const allowed = acesso.regional;

  const handleChange = (ev: any) => {
    const {
      target: { value },
    } = ev;

    if (props.onChange) {
      props.onChange(ev);
      dispatch(actionSelectRegional(value));
    } else {
      dispatch(actionSelectRegional(value));
    }
  };

  const resetSelects = () => {
    if (!props.onChange) {
      dispatch(actionSelectRegional(""));
    }
  };

  const regionalSelected = useAppSelector(
    (state) => state.getRegionais.regionalSelected,
  );
  const regionais = useAppSelector((state) => state.getRegionais.regionais);
  const divisaoSelected = useAppSelector(
    (state) => state.getDivisoes.divisaoSelected,
  );

  React.useEffect(() => {
    if (allowed) {
      dispatch(actionGetRegionais());
    }
  }, [divisaoSelected]);

  if (!allowed) {
    return null;
  }

  return (
    <Select
      options={factoryOptionsFields.regionais(regionais)}
      label="Cliente"
      name="idRegional"
      onChange={handleChange}
      value={props.idRegional || regionalSelected || ""}
      size="sm"
    />
  );
};

export default SelectRegionais;
